<template>
  <div class="main">
    <div class="left">
      <div class="left_title">
        功能目录
      </div>
      <Navbar @tableData="gettableData($event)"></Navbar>
    </div>
    <div class="right">
      <div class="right_title">
        系统功能管理
      </div>
      <div class="right_function">
        <div>
          <!-- <Input
          enter-button
          :clearable="true"
          placeholder="请输入搜索内容"
          style="width:220px;"
          v-model="searchData"
          @on-enter="searchBtn"
        /> -->
        </div>
        <div class="">
          <CModal
            msg="新增"
            icon="md-add"
            :parentId="tableData"
          ></CModal>
          <CModal
            msg="编辑"
            icon="ios-create"
            :handleSelectData="currentRow"
          ></CModal>
          <CModal
            msg="删除"
            icon="md-trash"
            :handleSelectData="currentRow"
          ></CModal>
          <!-- <Button
            icon="ios-apps"
            style="margin-left:10px"
            @click="addBtn"
          >
            添加按钮
          </Button> -->
        </div>
        <Modal
          v-model="modalBol"
          title="添加按钮"
          footer-hide
        >
          <div
            class="add"
            style="text-align:right;"
          >
            <Button
              @click="addBtnFnc('添加')"
              style="margin-left:5px"
            >添加</Button>
            <Button
              @click="addBtnFnc('编辑')"
              style="margin-left:5px"
            >编辑</Button>
            <Button
              @click="confirm"
              style="margin-left:5px"
            >删除</Button>
          </div>
          <el-table
            ref="singleTable"
            :data="btntableData"
            highlight-current-row
            @current-change="btnCurrentChange"
            style="width: 100%"
            stripe=""
          >
            <el-table-column
              type="index"
              width="80"
              label="序号"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="buttonname"
              label="名称"
              width="120"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="buttoncode"
              label="编号"
              width="120"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="url"
              label="地址"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="description"
              label="备注"
              align="center"
            >
            </el-table-column>
          </el-table>
        </Modal>
        <el-dialog
          title="提示"
          :visible.sync="dialogVisible"
          width="30%"
        >
          <el-form
            :model="addBtnForm"
            :rules="rules"
            ref="addBtnForm"
            label-width="80px"
            class="demo-addBtnForm"
          >
            <el-form-item
              label="编号"
              prop="buttoncode"
            >
              <el-input v-model="addBtnForm.buttoncode"></el-input>
            </el-form-item>
            <el-form-item
              label="名称"
              prop="buttonname"
            >
              <el-input v-model="addBtnForm.buttonname"></el-input>
            </el-form-item>
            <el-form-item
              label="排序"
              prop="sortcode"
            >
              <el-input v-model="addBtnForm.sortcode"></el-input>
            </el-form-item>
            <el-form-item label="地址">
              <el-input v-model="addBtnForm.url"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                @click="submitForm('addBtnForm')"
              >提交</el-button>
            </el-form-item>
          </el-form>
          </span>
        </el-dialog>
      </div>
      <el-table
        ref="singleTable"
        :data="tableData"
        highlight-current-row
        @current-change="handleCurrentChange"
        style="width: 100%"
      >
        <el-table-column
          type="index"
          width="50"
        >
        </el-table-column>
        <el-table-column
          property="modulecode"
          label="编号"
        >
        </el-table-column>
        <el-table-column
          property="modulename"
          label="名称"
        >
        </el-table-column>
        <el-table-column
          property="moduleurl"
          label="链接"
        >
        </el-table-column>
        <el-table-column
          property="isenable"
          label="有效"
        >
          <template slot-scope="scope">
            <el-switch
              :disabled="true"
              v-model="scope.row.isenable==1?scope.row.isenable=true:scope.row.isenable=false"
              active-color="#7ed6df"
              inactive-color="#ff7979"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column
          property="description"
          label="备注"
        >
        </el-table-column>
      </el-table>
    </div>

  </div>
</template>
<script>
import Api from '../../api/index'
import Navbar from '../../components/system/functionMenu'
import CModal from '../../components/system/functionBtn'

export default {
  data () {
    return {
      modalBol: false,
      dialogVisible: false,
      searchData: '',
      tableData: [],
      currentRow: null,
      btncurrentRow: null,
      switchValue: false,
      btntableData: [],

      addBtnForm: {
        moduleid: '',
        buttoncode: '',
        buttonname: '',
        sortcode: '',
        url: ''
      },
      rules: {
        buttoncode: [
          { required: true, message: '请输入编号', trigger: 'blur' },
        ],
        buttonname: [
          { required: true, message: '请输入编号', trigger: 'blur' },
        ],
        sortcode: [
          { required: true, message: '请输入排序', trigger: 'blur' },
          { min: 1, max: 5, message: '长度在 1 到 5 个字符', trigger: 'blur' }
        ],
      }
    }
  },
  components: {
    Navbar,
    CModal
  },
  created () {

  },
  mounted () {

  },

  methods: {
    //获取子菜单列表
    gettableData (val) {
      this.tableData = val
    },
    //搜索按钮
    searchBtn () {
      console.log(this.searchData);
    },
    //表格选中项
    handleCurrentChange (val) {
      this.currentRow = val;
    },
    //按钮表格选中项
    btnCurrentChange (val) {
      this.btncurrentRow = val;
    },
    //获取当前菜单的按钮
    async GetDataList () {
      const res = await Api.sysFunction.GetDataList(this.currentRow.moduleid)
      if (res.success != true) return this.$Message.info(res.msg)
      this.btntableData = res.rows
    },
    async addBtn () {
      if (this.currentRow != null) {
        this.GetDataList()
        this.modalBol = true
        this.addBtnForm.moduleid = this.currentRow.moduleid
      } else {
        this.$Message.info('请选择所要添加的功能目录！')
      }
    },
    async addBtnFnc (msg) {
      if (msg == '添加') {
        this.dialogVisible = true;
        this.addBtnForm = {
          moduleid: '',
          buttoncode: '',
          buttonname: '',
          sortcode: '',
          url: ''
        }
      } else if (msg == '编辑') {
        if (this.btncurrentRow == null) return this.$Message.info('请选择所要编辑的按钮!')
        this.dialogVisible = true;
        const res = await Api.sysFunction.GetBtnDataById(this.btncurrentRow.modulebuttonid)
        if (res.success != true) return this.$Message.info(res.msg)
        this.addBtnForm = res.rows
        this.addBtnForm.sortcode = res.rows.sortcode + ''
      }
    },
    submitForm (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const res = await Api.sysFunction.SaveBtnData(this.addBtnForm)
          if (res.success != true) return this.$Message.info(res.msg)
          this.$Message.success(res.msg)
          this.GetDataList()
          this.dialogVisible = false
        } else {
          return false;
        }
      });
    },
    confirm () {
      if (this.btncurrentRow == null) return this.$Message.info("请选择需要删除的按钮！")
      this.$Modal.confirm({
        title: '删除按钮',
        content: '<p>是否确认删除按钮?</p>',
        onOk: async () => {
          const res = await Api.sysFunction.DelBtnData([this.btncurrentRow.modulebuttonid])
          if (res.success != true) return this.$Message.info(res.msg)
          this.$Message.info('删除成功');
        },

      });
    },

  },
}
</script>
<style lang='less' scoped>
.main {
  display: flex;
  justify-content: space-between;
  height: 100%;
  width: 100%;

  .left,
  .right {
    border: 1px solid #f0eeff;
    border-radius: 3px;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
  }
  .left {
    width: 12%;
    height: 100%;
    background-color: #fff;
    .left_title {
      height: 40px;
      line-height: 40px;
      text-align: center;
      font-size: 15px;
      font-weight: 600;
      color: #fff;
      background-color: #1874cd;
    }
  }
  .right {
    width: 87%;
    height: 100%;
    background-color: #fff;

    .right_function {
      display: flex;
      justify-content: space-between;
      padding: 10px 20px;
    }
    .right_title {
      color: #666;
      font-size: 15px;
      font-weight: 600;
      border-bottom: 1px solid #c7ebf3;
      height: 40px;
      line-height: 40px;
      padding-left: 20px;
    }
  }
}
</style>